import MarkdownIt from "markdown-it";
import React from "react";

const markdownRenderer = new MarkdownIt({ typographer: true });

const Markdown = React.memo(function Markdown(props: { children: string }) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: markdownRenderer.render(props.children),
      }}
    ></div>
  );
});

export default Markdown;
